/* eslint-disable camelcase */
import React from "react";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { resetError } from "../../actions/errors";
import PinModal from "../../components/pin";
import { fetchDstRegion, saveDstRegion } from "../../actions/dst-regions";
import { dstRegionsPath } from "../../routes";
import { MONTH_NAMES } from "../../constants/month-names";
import { WEEKDAY_NAMES } from "../../constants/weekday-names";
import { WEEKDAY_ORDINALS } from "../../constants/weekday-ordinal";

const numericColumns = [
  "start_month",
  "start_weekday",
  "start_weekday_ordinal",
  "end_month",
  "end_weekday",
  "end_weekday_ordinal",
];

class DstRegionEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.failedSubmit = this.failedSubmit.bind(this);
  }

  componentWillMount() {
    const { getDstRegion } = this.props;
    getDstRegion();
  }

  handleChange(e, name) {
    const { value } = e.target;
    if (numericColumns.includes(name.toLowerCase())) {
      this.setState({ [name]: Number(value) });
    } else {
      this.setState({ [name]: value });
    }
  }

  requestSubmit(e) {
    e.preventDefault();
    this.setState({
      submitted: true,
    });
  }

  failedSubmit() {
    this.setState({
      submitted: false,
    });
  }

  handleSubmit() {
    const {
      saveDstRegionAction,
      goToShow,
      resetErrorAction,
      dstRegion,
    } = this.props;

    resetErrorAction();

    const {
      display_name,
      start_month,
      start_weekday,
      start_weekday_ordinal,
      end_month,
      end_weekday,
      end_weekday_ordinal,
    } = this.state;
    const body = {
      display_name: display_name ? display_name : dstRegion.display_name,
      start: {
        id: dstRegion.start.id,
        month: start_month ? start_month : dstRegion.start.month,
        weekday: start_weekday ? start_weekday : dstRegion.start.weekday,
        weekday_ordinal: start_weekday_ordinal
          ? start_weekday_ordinal
          : dstRegion.start.weekday_ordinal,
      },
      end: {
        id: dstRegion.end.id,
        month: end_month ? end_month : dstRegion.end.month,
        weekday: end_weekday ? end_weekday : dstRegion.end.weekday,
        weekday_ordinal: end_weekday_ordinal
          ? end_weekday_ordinal
          : dstRegion.end.weekday_ordinal,
      },
    };
    Object.keys(body).forEach(
      (key) => body[key] === undefined && delete body[key],
    );

    saveDstRegionAction(dstRegion.id, {
      body: JSON.stringify(body),
    }).then(() => goToShow());
  }

  render() {
    const { dstRegion } = this.props;
    const {
      display_name,
      start_month,
      start_weekday,
      start_weekday_ordinal,
      end_month,
      end_weekday,
      end_weekday_ordinal,
      submitted,
    } = this.state;
    if (!dstRegion || Object.keys(dstRegion).length === 0) {
      return null;
    }
    return (
      <div className="animated fadeIn">
        {submitted && (
          <PinModal
            successSubmit={this.handleSubmit}
            failedSubmit={this.failedSubmit}
          />
        )}
        <Row>
          <Col lg={8}>
            <Card>
              <Form onSubmit={(e) => this.requestSubmit(e)}>
                <CardHeader>
                  <strong>
                    {"Edit DST Region: "}
                    {dstRegion.id}
                  </strong>
                </CardHeader>
                <CardBody>
                  <FormGroup>
                    <Label htmlFor="display_name">Name</Label>
                    <Input
                      id="display_name"
                      type="text"
                      placeholder="Enter Name"
                      invalid={submitted && display_name === ""}
                      onChange={(e) => this.handleChange(e, "display_name")}
                      defaultValue={dstRegion.display_name}
                      required
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="start_month">Start Month</Label>
                    <Input
                      type="select"
                      name="start_month"
                      id="start_month"
                      invalid={submitted && !MONTH_NAMES[start_month]}
                      onChange={(e) => this.handleChange(e, "start_month")}
                      defaultValue={dstRegion.start.month}
                      required
                    >
                      {MONTH_NAMES.map((month, index) => (
                        <option key={month} value={index}>
                          {month}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="start_weekday">Start Weekday</Label>
                    <Input
                      type="select"
                      name="start_weekday"
                      id="start_weekday"
                      invalid={submitted && !WEEKDAY_NAMES[start_weekday]}
                      onChange={(e) => this.handleChange(e, "start_weekday")}
                      defaultValue={dstRegion.start.weekday}
                      required
                    >
                      {WEEKDAY_NAMES.map((item, index) => (
                        <option key={item} value={index}>
                          {item}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="start_weekday_ordinal">
                      Start Weekday Ordinal
                    </Label>
                    <Input
                      type="select"
                      name="start_weekday_ordinal"
                      id="start_weekday_ordinal"
                      defaultValue={dstRegion.start.weekday_ordinal}
                      invalid={
                        submitted &&
                        !WEEKDAY_ORDINALS.find(
                          (item) => item.value === start_weekday_ordinal,
                        )
                      }
                      onChange={(e) =>
                        this.handleChange(e, "start_weekday_ordinal")
                      }
                      required
                    >
                      {WEEKDAY_ORDINALS.map((item) => (
                        <option key={item.value} value={item.value}>
                          {item.description}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="end_month">End Month</Label>
                    <Input
                      type="select"
                      name="end_month"
                      id="end_month"
                      invalid={submitted && !MONTH_NAMES[end_month]}
                      onChange={(e) => this.handleChange(e, "end_month")}
                      defaultValue={dstRegion.end.month}
                      required
                    >
                      {MONTH_NAMES.map((month, index) => (
                        <option key={month} value={index}>
                          {month}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="end_weekday">End Weekday</Label>
                    <Input
                      type="select"
                      name="end_weekday"
                      id="end_weekday"
                      invalid={submitted && !WEEKDAY_NAMES[end_weekday]}
                      onChange={(e) => this.handleChange(e, "end_weekday")}
                      defaultValue={dstRegion.end.weekday}
                      required
                    >
                      {WEEKDAY_NAMES.map((item, index) => (
                        <option key={item} value={index}>
                          {item}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="end_weekday_ordinal">
                      End Weekday Ordinal
                    </Label>
                    <Input
                      type="select"
                      name="end_weekday_ordinal"
                      id="end_weekday_ordinal"
                      invalid={
                        submitted &&
                        !WEEKDAY_ORDINALS.find(
                          (item) => item.value === end_weekday_ordinal,
                        )
                      }
                      onChange={(e) =>
                        this.handleChange(e, "end_weekday_ordinal")
                      }
                      defaultValue={dstRegion.end.weekday_ordinal}
                      required
                    >
                      {WEEKDAY_ORDINALS.map((item) => (
                        <option key={item.value} value={item.value}>
                          {item.description}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </CardBody>
                <CardFooter>
                  <Button type="submit" size="sm" color="success">
                    Save
                  </Button>{" "}
                  <Button
                    href={`/#/${dstRegionsPath}/${dstRegion.id}`}
                    size="sm"
                    color="danger"
                  >
                    Cancel
                  </Button>
                </CardFooter>
              </Form>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = ({ dstRegions }) => ({
  dstRegion: dstRegions.item,
});
const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      getDstRegion: () => fetchDstRegion(ownProps.match.params.id),
      goToShow: () => push(`/${dstRegionsPath}/${ownProps.match.params.id}`),
      resetErrorAction: () => resetError(),
      saveDstRegionAction: (id, body) => saveDstRegion(id, body),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DstRegionEdit);
